module.exports = __webpack_public_path__ + "web/img/news-default.244c6e18.png";